import React from "react";
import "./FlightPopupCard.css";

const FlightPopupCard = ({ title, price, selected, onSelect, services, currency }) => {
  return (
    <div
      className={`flight-popup-card ${selected ? "selected" : ""}`}
      onClick={onSelect}
    >
      <div className="flight-popup-card-title">
        <label className="radio-label flight-card-radio-container">
          <input
            type="radio"
            name="flight-option"
            checked={selected}
            onChange={onSelect}
          />
          <span className="custom-radio"></span>
          <span className="flight-popup-card-title-label">{title}</span>
        </label>
      </div>

      <div className="flight-popup-card-desc">
        <span>Included Services</span>
        <ul>
          {
            services?.map((item, index) => (
              <li key={index}>{item}</li>
            ))
          }
        </ul>
      </div>

      <div className="flight-popup-card-price">{currency} {price}</div>
    </div>
  );
};

export default FlightPopupCard;
